import { render, staticRenderFns } from "./course_range.vue?vue&type=template&id=832b1334&scoped=true"
import script from "./course_range.vue?vue&type=script&lang=js"
export * from "./course_range.vue?vue&type=script&lang=js"
import style0 from "./course_range.vue?vue&type=style&index=0&id=832b1334&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832b1334",
  null
  
)

export default component.exports